module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidade")]), _vm._v(" "), _c('select-unidade', {
    attrs: {
      "tipo": _vm.TIPO_CONTRATO.PRESTADOR
    },
    on: {
      "setUnidadeSelecionada": function (unidadeSelecionada) {
        _vm.setUnidadeSelecionada(
          unidadeSelecionada
        );
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('nivel'),
    }
  }, [_c('label', {
    attrs: {
      "for": "nivel"
    }
  }, [_vm._v("Perfil:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.nivel),
      expression: "filtros.nivel"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nivel",
      "type": "text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "nivel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "administrador"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tAdministrador\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "regulador"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tRegulador\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "marcador"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tMarcador\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "prestador"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tPrestador\n\t\t\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    class: {
      'form-group': true,
      'has-error': _vm.errors.has('situacao'),
    }
  }, [_c('label', {
    attrs: {
      "for": "situacao"
    }
  }, [_vm._v("Situação:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacao),
      expression: "filtros.situacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "situacao",
      "type": "text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inativo")])])])])]), _vm._v(" "), _c('div', {
    ref: "filtrar",
    staticClass: "box-footer text-right"
  }, [(_vm.pdf) ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tRecarregar PDF\n\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Pesquisar Relatório de Usuários",
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        _vm.getDataTable()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar\n\t\t\t\t\t\t")])]), _vm._v(" "), (_vm.pdf) ? _c('div', [_c('embed', {
    attrs: {
      "type": "application/pdf",
      "src": _vm.pdf,
      "width": "100%",
      "height": _vm.heigthPdf
    }
  })]) : _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.login))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nivel))]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("unidades")(item.unidades)) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("situacao")(item.situacao)) + "\n\t\t\t\t\t\t\t\t\t\t\t")])])
  }))]), _vm._v(" "), (
    _vm.dataTable.data &&
    _vm.dataTable.data.length > 0
  ) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tMostrando\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(this.dataTable.from) + " até\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(this.dataTable.to) + " de\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(this.dataTable.total) + " registros\n\t\t\t\t\t\t\t\t\t\tencontrados.\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 text-right"
  }, [_c('button', {
    staticClass: "btn btn-info pdf",
    attrs: {
      "disabled": _vm.finalizado
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        return _vm.getPDF($event)
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file-pdf-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\tPDF\n\t\t\t\t\t\t\t\t\t\t")])])]) : _vm._e()])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Usuários")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "17%"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tUsuário\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "17%"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tEmail\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tNível\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tUnidades\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tSituação\n\t\t\t\t\t\t\t\t\t\t\t")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3651f592"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/relatorios/usuarios/index.vue
// module id = 828
// module chunks = 0